/**
 * ============================================================================
 * CSS TEMPLATES
 * ============================================================================
 * 
 * CSS template strings for theme application
 */

import { withOpacity, darkenColor } from './color-utils';

/**
 * Generates Bootstrap and component overrides CSS for whitelabel users
 * @param {string} primaryColor - Primary color hex
 * @param {string} primaryHover - Primary hover color hex
 * @param {string} primaryShadow - Primary shadow CSS value
 * @param {string} primaryShadowHover - Primary hover shadow CSS value
 * @returns {string} CSS string
 */
export function generateWhitelabelOverrides(primaryColor, primaryHover, primaryShadow, primaryShadowHover) {
  return `
/* ========== WHITELABEL THEME OVERRIDES ========== */
/* Bootstrap Vue Primary Variant Overrides (runtime theme) */
// body .btn-primary,
// body .btn.btn-primary,
// body .show > .btn-primary.dropdown-toggle,
// body .badge-primary,
// body .bg-primary,
// body .alert-primary,
// body .list-group-item-primary,
// body .table-primary,
// body .border-primary {
//   background-color: var(--brand-primary) !important;
//   border-color: var(--brand-primary) !important;
//   color: var(--brand-primary-text) !important;
//   box-shadow: ${primaryShadow} !important;
//   background-image: none !important; /* prevent potential gradients */
// }

// body .btn-primary:hover,
// body .btn.btn-primary:hover,
// body .btn-primary:focus,
// body .btn.btn-primary:focus,
// body .btn-primary:active,
// body .btn.btn-primary:active,
// body .btn-primary.active,
// body .btn.btn-primary.active {
//   background-color: ${primaryHover} !important;
//   border-color: ${primaryHover} !important;
//   color: var(--brand-primary-text) !important;
//   box-shadow: ${primaryShadowHover} !important;
// }

// body .btn-outline-primary,
// body .btn.btn-outline-primary {
//   color: var(--brand-primary) !important;
//   border-color: var(--brand-primary) !important;
//   background-color: transparent !important;
// }

// body .btn-outline-primary:hover,
// body .btn.btn-outline-primary:hover,
// body .btn-outline-primary:focus,
// body .btn.btn-outline-primary:focus,
// body .btn-outline-primary:active,
// body .btn.btn-outline-primary:active {
//   background-color: var(--brand-primary) !important;
//   border-color: var(--brand-primary) !important;
//   color: var(--brand-primary-text) !important;
// }

// body .text-primary,
// body a.text-primary,
// body .hover-primary:hover {
//   color: var(--brand-primary) !important;
// }

// body .badge-primary {
//   background-color: var(--brand-primary) !important;
//   color: var(--brand-primary-text) !important;
// }

// /* Links global override */
// body a:not(.btn):not(.badge):not(.dropdown-item):not(.nav-link):not(.page-link),
// body .b-link {
//   color: var(--link-color);
// }

// body a:not(.btn):not(.badge):not(.dropdown-item):not(.nav-link):not(.page-link):hover,
// body .b-link:hover {
//   color: var(--link-hover);
//   opacity: 0.8;
// }

// /* Custom controls (BootstrapVue: b-form-checkbox, b-form-radio, b-form-switch) */
// body .custom-control-input:checked ~ .custom-control-label::before {
//   background-color: var(--brand-primary) !important;
//   border-color: var(--brand-primary) !important;
// }

// body .custom-control-input:focus ~ .custom-control-label::before {
//   border-color: var(--brand-primary) !important;
//   box-shadow: 0 0 0 0.2rem ${withOpacity(primaryColor, 0.25)} !important;
// }

// body .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
//   background-color: ${darkenColor(primaryColor, 10)} !important;
//   border-color: ${darkenColor(primaryColor, 10)} !important;
// }

// body .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
//   border-color: var(--brand-primary) !important;
// }

// body .custom-switch .custom-control-input:checked ~ .custom-control-label::before {
//   background-color: var(--brand-primary) !important;
//   border-color: var(--brand-primary) !important;
// }

// /* Form inputs (BootstrapVue: b-form-input, b-form-textarea, b-form-select) */
// body .form-control:focus,
// body input.form-control:focus,
// body textarea.form-control:focus,
// body select.form-control:focus {
//   border-color: var(--brand-primary) !important;
// }

// body .form-control:focus-visible,
// body input.form-control:focus-visible,
// body textarea.form-control:focus-visible,
// body select.form-control:focus-visible {
//   outline: 0;
//   border-color: var(--brand-primary) !important;
// }

// /* Input group addons (BootstrapVue: b-input-group-prepend, b-input-group-append) */
// body .input-group:focus-within .input-group-prepend .input-group-text,
// body .input-group:focus-within .input-group-append .input-group-text {
//   border-color: var(--brand-primary) !important;
// }

// body .input-group-prepend .input-group-text,
// body .input-group-append .input-group-text {
//   transition: border-color 0.15s ease-in-out;
// }

// /* Dropdown items (BootstrapVue: b-dropdown) */
// body .dropdown-item:hover,
// body .dropdown-item:focus {
//   background-color: ${withOpacity(primaryColor, 0.1)} !important;
//   color: var(--brand-primary) !important;
// }

// body .dropdown-item:active,
// body .dropdown-item.active {
//   background-color: var(--brand-primary) !important;
//   color: var(--brand-primary-text) !important;
// }

// body .dropdown-divider {
//   border-top-color: ${withOpacity(primaryColor, 0.2)} !important;
// }

// /* Vue-select components */
// body .vs__dropdown-toggle {
//   border-color: #d8d8d8 !important;
// }

// body .vs--open .vs__dropdown-toggle {
//   border-color: var(--brand-primary) !important;
// }

// body .vs__dropdown-option--highlight,
// body .vs__dropdown-option--highlight:hover {
//   background-color: var(--brand-primary) !important;
//   color: var(--brand-primary-text) !important;
// }

// body .vs__dropdown-option--selected,
// body .vs__dropdown-option.vs__dropdown-option--selected {
//   background-color: ${withOpacity(primaryColor, 0.15)} !important;
//   color: var(--brand-primary) !important;
// }

// body .vs__dropdown-option--selected.vs__dropdown-option--highlight,
// body .vs__dropdown-option--selected:hover,
// body .vs__dropdown-option.vs__dropdown-option--selected:hover {
//   background-color: var(--brand-primary) !important;
//   color: var(--brand-primary-text) !important;
// }

// body .vs__open-indicator,
// body .vs__open-indicator path {
//   fill: var(--brand-primary) !important;
// }

// body .vs__clear,
// body .vs__clear path {
//   fill: var(--brand-primary) !important;
// }

// body .v-select.vs--open .vs__selected {
//   opacity: 0.4;
// }

// /* Bootstrap Vue Tabs (b-tabs) */
// body .nav-tabs .nav-link.active:not([class*="colorTab"]),
// body .nav-tabs .nav-item.show .nav-link:not([class*="colorTab"]) {
//   color: var(--brand-primary) !important;
// }
`;
}

/**
 * Generates utility classes CSS (always applied)
 * @returns {string} CSS string
 */
export function generateUtilityClasses() {
  return `
/* ========== UTILITY CLASSES WITH FALLBACK (ALL USERS) ========== */
/* Text color utilities */
body .text-blue {
  color: var(--primary-for-blue-cases, #0096fe) !important;
}

body .text-blue:hover {
  color: var(--primary-for-blue-cases, #0094fec5) !important;
}

/* Blue button utilities */
body .blue-button,
body .btn.blue-button {
  background-color: var(--primary-for-blue-cases, #0096fe) !important;
  border: 0 !important;
  color: white !important;
}

body .blue-button:hover,
body .btn.blue-button:hover {
  background-color: var(--primary-for-blue-cases, rgb(77, 182, 249)) !important;
  box-shadow: var(--primary-shadow-blue, rgba(77, 182, 249, 0.3) 0px 7px 29px 0px) !important;
  color: white !important;
}

body .blue-button:focus,
body .btn.blue-button:focus {
  background-color: var(--primary-for-blue-cases, #0096fe) !important;
  color: white !important;
}

body .blue-button:disabled,
body .btn.blue-button:disabled {
  background-color: var(--primary-for-blue-cases, #0094fe86) !important;
  color: white !important;
}

body .blue-button:disabled:hover,
body .btn.blue-button:disabled:hover {
  box-shadow: none !important;
  color: white !important;
}

body .blue-button-next-step {
  background-color: var(--primary-for-blue-cases, #5582f6) !important;
  border: 0 !important;
  color: white !important;
} 
body .blue-button-next-step:hover {
  background-color: var(--primary-for-blue-cases, #4569c4) !important;
  color: white !important;
}
body .blue-button-next-step:disabled:hover {
  background-color: none !important;
  box-shadow: none !important;
  color: white !important;
}

body .active-class-button > .card-radion-button-steps {
  border: 0.0625rem solid var(--primary-for-blue-cases, #5582f6); 
}
body .active-class-button > .card-radion-button-steps > .background-left-proposal {
  background-color: var(--primary-for-blue-cases, #5582f6)  !important;
}
body .link-back {
  color: var(--primary-for-blue-cases, #5582f6) !important;
}
body .link-back:hover {
  color: var(--primary-for-blue-cases, #4569c4) !important;
}

body .form-control.is-valid,
body .form-control.is-valid {
  border-color: var(--brand-primary, var(--primary-for-blue-cases, #3483fa)) !important;
}

body .form-control.is-valid:focus,
body .form-control.is-valid:focus {
  border-color: var(--brand-primary, var(--primary-for-blue-cases, #3483fa)) !important;
}

body .form-control:focus {
body .form-control:focus {
  border-color: var(--brand-primary, var(--primary-for-blue-cases, #3483fa)) !important;
}


/* Button max views utilities */
body .button-max-views,
body .btn.button-max-views {
  background: var(--primary-gradient-button, linear-gradient(to left bottom, rgb(124, 214, 175), rgb(62, 123, 160))) !important;
  color: white !important;
  border-color: var(--primary-for-blue-cases, transparent) !important;
}

body .button-max-views:hover,
body .btn.button-max-views:hover {
  background: var(--primary-gradient-button-hover, linear-gradient(to left bottom, rgba(124, 214, 175, 0.884), rgba(62, 122, 160, 0.842))) !important;
}
`;
}
